<template>
  <div>
      <h2 class="text-1xl font-bold text-gray-700 mb-3">
        Listado de ventas temporales
      </h2>
    <MainTemporarySales />
  </div>
</template>

<script>
import MainTemporarySales from "@/components/TemporarySales/MainTemporarySales.vue";
import { useRoute } from "vue-router";
import { onBeforeMount, onMounted } from "vue";
import { findSubmoduleIdByDescription } from "@/hisAcces";
export default {
  name: "TemporarySales",
  components: {
    MainTemporarySales,
  },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
};
</script>
